import { useUser } from "@/contexts/UserContext";
import { Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

const ManagerGuard: React.FC = () => {
  const { isManager, isLoading } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;
    if (!isManager) navigate({ to: "/error/401" });
  }, [isLoading, isManager, navigate]);
  if (isLoading || !isManager) return null;

  return <Outlet />;
};

export default ManagerGuard;
